import axios from 'axios'

import config from '../../config'

const updateAuthRole = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/AuthRoles`
  return axios.put(url, data)
}

export default updateAuthRole
